document.addEventListener("DOMContentLoaded", () => {
  const addToCartButtons = document.querySelectorAll("[data-add-to-cart]");
  const cartRecommendations = document.querySelector("cart-recommendations");

  if (!cartRecommendations) return;

  // Get values from dataset or use defaults if not provided
  let baseUrl = cartRecommendations.dataset.baseUrl;
  let sectionId = cartRecommendations.dataset.sectionId;

  // Set default values if they don't exist
  if (!baseUrl) {
    baseUrl = window.location.origin + "/recommendations/products";
    cartRecommendations.dataset.baseUrl = baseUrl;
    console.log("Using default base URL for recommendations:", baseUrl);
  }

  if (!sectionId) {
    sectionId = "product-recommendations";
    cartRecommendations.dataset.sectionId = sectionId;
    console.log("Using default section ID for recommendations:", sectionId);
  }

  addToCartButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();

      const form = button.closest("form");
      const formData = new FormData(form);

      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((product) => {
          fetch("/cart.json")
            .then((response) => response.json())
            .then((cart) => {
              const addedProduct = cart.items.find(
                (item) => item.id === product.id
              );

              if (addedProduct) {
                const productId = addedProduct.product_id;

                const newUrl = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=6&intent=related`;

                cartRecommendations.dataset.url = newUrl;

                fetch(newUrl)
                  .then((response) => response.text())
                  .then((html) => {
                    const recommendationsHTML = new DOMParser()
                      .parseFromString(html, "text/html")
                      .querySelector("[data-recommendations]").innerHTML;

                    cartRecommendations.querySelector(
                      "[data-recommendations]"
                    ).innerHTML = recommendationsHTML;
                    cartRecommendations.classList.remove("hidden");
                  });
              }
            });
        })
        .catch((error) => {
          console.error("Add to cart error:", error);
        });
    });
  });
});
